module.exports = __webpack_public_path__ + "img/RCenturion64_ua.ca376780.webp";